"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneLinkFactory = void 0;
const onelink_1 = require("../onelink");
class OneLinkFactory {
    constructor(config) {
        this._factoryConfig = config;
    }
    create(config = {}) {
        return new onelink_1.OneLink(this._factoryConfig, config);
    }
}
exports.OneLinkFactory = OneLinkFactory;
